import OrganizationDetailsPage from "./OrganizationDetailsPage";
export default OrganizationDetailsPage;

export * from "./OrganizationDetailsPage.new";
